"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Catch_1 = require("../../Catch");
var ParamExtractor_1 = require("@wix/dealer-common/dist/src/services/ParamExtractor");
function CmsImage(props) {
    return (React.createElement(Catch_1.Catch, { onError: props.onError, render: function () {
            var context = props.context;
            var hoverSrc = ParamExtractor_1.extractParam(props.element, context, 'hoverSrc');
            var noHoverSrc = ParamExtractor_1.extractParam(props.element, context, 'src');
            var src = props.hover && hoverSrc ? hoverSrc : noHoverSrc;
            return React.createElement("img", { src: "//static.wixstatic.com" + src });
        } }));
}
exports.CmsImage = CmsImage;
//# sourceMappingURL=CmsImage.js.map